<script>
    import { onMount } from 'svelte';
    import { fetchOneCourse } from '/public/services/courses.js';
    import { navigateTo } from 'svelte-router-spa';
    import CourseStartEnd from '/shared/c/courses/list/parts/CourseStartEnd.svelte';
    import { mapIsReady } from '/core/stores/mapReady.js';
    import VenueMap from '/public/components/courses/parts/VenueMap.svelte';
    import { Progress } from '@sveltestrap/sveltestrap';

    export let currentRoute;

    let id = currentRoute.namedParams.courseID;
    let course = null;
    let loading = true;


    function loadCourse() {
        fetchOneCourse(id).then(res => {
            if (res.success) {
                course = res.data.course;
                loading = false;
            } else {
                navigateTo('/home');
            }
        })
    }

    let gm_ready;

    const gm_subs = mapIsReady.subscribe(v => {
        gm_ready = v;
    });

    function goBack() {
        window.history.back();
    }

    onMount(() => {
        loadCourse();
    });

</script>
{#if loading === true}

    <div class='text-center'>
        <h4>
            <span class='ajax-ball-loader'></span> Loading Course....
        </h4>
    </div>

{:else}

    <p class='text-end'>
        <button class='btn btn-outline-secondary' on:click={goBack}>
            <span class='fas fa-chevron-left'></span> All Courses
        </button>
    </p>

    {#if course.can_book === true}

        <div class='text-center'>
            <div class='d-grid'>
                <a href='/book-course/{ id }' class='btn btn-success btn-lg'>
                    <span class='fas fa-plus-circle'></span> Book this Course
                </a>
            </div>
        </div>

    {:else}

        <div class='alert alert-info clearfix'>
            <h4 class='float-start me-2'>
                <span class='fas fa-info-circle'></span>
            </h4>
            <p>
                This Course cannot be booked at this time. Please email <a href="mailto:{ course.support_email }">{ course.support_email }</a> or call <span class='fw_bold'>{ course.support_phone }</span> to enquire about this Course.
            </p>
        </div>

    {/if}

    <hr/>

    <div class='row'>
        <div class='col-md-8'>
            <div class='card mb-3'>
                <div class='card-header'>

                    { course.title }

                </div>
                <div class='card-body'>
                    <h4>

                        <CourseStartEnd course={course}/>

                    </h4>

                    <div class='mb-3'>
                        <Progress 
                            value={course.percent}
                            color='success'
                            striped                
                        >
                            <span class='fw-bold'>
                                { course.percent }%
                            </span>
                        </Progress>
                    </div>

                    {#if course.instructors.length > 0}

                        <h5>
                            Instructors
                        </h5>
                        <div class='list-group mb-3'>

                            {#each course.instructors as ii}

                                <div class='list-group-item'>

                                    <span class='fas fa-user-tie'></span> { ii }

                                </div>

                            {/each}

                        </div>

                    {/if}

                    {#if course.types.length > 0}

                        <h5>
                            Course Types
                        </h5>
                        <div class='list-group mb-3'>

                            {#each course.types as t}

                                <div class='list-group-item clearfix'>
                                    <span class='float-end ms-2'>
                                        ${ t.price }
                                    </span>

                                    { t.title }
                                    
                                </div>

                            {/each}

                        </div>

                    {/if}

                    <h5>
                        Course Information
                    </h5>
                    <small>

                        {@html course.description}

                    </small>
                </div>
            </div>
        </div>
        <div class='col-md-4'>
            <div class='card mb-3'>
                <div class='card-header'>
                    Venue
                </div>
                <div class='card-body'>
                    <p>
                        { course.venue }
                    </p>

                    {#if gm_ready === true}

                        <VenueMap lat={course.lat} lon={course.lon}/>

                    {/if}
                </div>
            </div>           
        </div>
    </div>

{/if}